export default class SolicitacaoAgendamento{
    idUsuarioResponsavel = "";
    funcionario = "";
    cpf= "";
    cargo = "";
    cbo = ""
    periodo = ""
    idExame = ""
}



// WEBPACK FOOTER //
// ./src/model/SolicitacaoAgendamento.js